import unchecked from './unchecked.svg';
import checked from './checked.svg';
import partial from './partial.svg';
import disabledUnchecked from './disabled-unchecked.svg';
import disabledChecked from './disabled-checked.svg';
import disabledPartial from './disabled-partial.svg';

export default {
  unchecked,
  checked,
  partial,
  'disabled unchecked': disabledUnchecked,
  'disabled checked': disabledChecked,
  'disabled partial': disabledPartial,
};
